<template>
  <v-container fluid id="truckSchedule" class="pa-0 pa-sm-3">
    <v-dialog v-model="dialog" width="500">
      <v-card v-if="currentTruck">
        <!-- CARD TITLE -->
        <v-card-title class="mb-0 pb-0" v-if="currentTruck">
          <h1 class="title mb-2">
            {{ currentTruck.displayName }}
            <div v-if="currentTruck.driver" class="caption">
              DRIVER:
              <strong>
                {{ currentTruck.driver.firstName }}
                {{ currentTruck.driver.lastName }} </strong
              ><br />
              <span v-if="currentTruck.lastTrack && currentTruck.lastTrack.timestamp">
                Last tracked:
                <strong>{{
                  currentTruck.lastTrack.timestamp | moment("MMM Do h:mma")
                }}</strong>
              </span>
            </div>
          </h1>
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-html="iframe" />
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-card-text class="pt-4">
          Driver has not been assigned a truck.
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row wrap justify="center">
      <v-col xs="9" class="headline pb-0">Truck Schedule</v-col>
      <!--  TRUCK REQUESTS -->
      <v-col cols="12" xs="12">
        <v-card>
          <v-tabs>
            <v-tab
              @click="
                orderType = 'scheduledRequests';
                page = 1;
              "
            >
              SCheduled
            </v-tab>
            <v-tab
              @click="
                orderType = 'closedRequests';
                page = 1;
              "
            >
              Recently Closed
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentTruckRequests"
            :headers="headers"
            sort-by="requestType"
            :items-per-page="100"
          >
            <template v-slot:item.jobSite.address="{ item }">
              {{ item.jobSite.street }}
              <div class="caption">({{ item.jobSite.jobId }})</div>
            </template>
            <template v-slot:item.scheduledTime="{ item }">
              {{ item.scheduledTime }}
              <div class="caption">
                <strong>{{ item.scheduledDay.displayDate }}</strong>
              </div>
            </template>
            <template v-slot:item.requestType="{ item }">
              <truck-request-details :showNotes="false" :order="item" />
            </template>
            <template v-slot:item.orderedBy="{ item }">
              {{ item.orderedBy.firstName }}
              {{ item.orderedBy.lastName }}
              <div class="grey--text caption">
                on
                {{ item.orderDate.toDate() | moment("MMM Do [at] h:mma") }}
              </div>
            </template>
            <template v-slot:item.scheduledDriver="{ item }">
              {{ item.scheduledDriver.firstName }}
              {{ item.scheduledDriver.lastName }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                v-if="item.status == 'scheduled'"
                @click.stop="viewLocation(item)"
                ><v-icon left small>room</v-icon> Location</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import utils from "@/helpers/utils";
import truckRequestDetails from "@/components/truckRequests/truckRequestDetails";
export default {
  components: {
    truckRequestDetails,
  },
  data() {
    return {
      search: "",
      orderType: "scheduledRequests",
      dialog: false,
      scheduledRequests: [],
      closedRequests: [],
      headers: [
        { text: "Job", value: "jobSite.address", width: 300 },
        { text: "Time", value: "scheduledTime", width: 180 },
        { text: "Details", value: "requestType" },
        { text: "Requested By", value: "orderedBy" },
        {
          text: "Driver",
          value: "driverName",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      currentTruck: null,
      iframe: "<div></div>",
    };
  },
  computed: {
    currentTruckRequests: function() {
      return this[this.orderType];
    },
  },
  async created() {
    this.unsubscribeScheduledRequests = await fb.db
      .collection("truckRequests")
      .where("status", "==", "scheduled")
      .onSnapshot((querySnapshot) => {
        let scheduledRequests = [];
        querySnapshot.forEach(function(doc) {
          scheduledRequests.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        // console.log(scheduledRequests);
        scheduledRequests = scheduledRequests.map((sr) => {
          return {
            driverName: sr.scheduledDriver
              ? `${sr.scheduledDriver.firstName} ${sr.scheduledDriver.lastName}`
              : "",
            ...sr,
          };
        });
        this.scheduledRequests = scheduledRequests;
      });
    this.unsubscribeClosedRequests = await fb.db
      .collection("truckRequests")
      .where("status", "==", "closed")
      .limit(50)
      .onSnapshot((querySnapshot) => {
        let closedRequests = [];
        querySnapshot.forEach(function(doc) {
          closedRequests.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        // console.log(closedRequests);
        closedRequests = closedRequests.map((sr) => {
          return {
            driverName: sr.scheduledDriver
              ? `${sr.scheduledDriver.firstName} ${sr.scheduledDriver.lastName}`
              : "",
            ...sr,
          };
        });
        this.closedRequests = closedRequests;
      });
  },
  beforeDestroy() {
    this.unsubscribeScheduledRequests();
    this.unsubscribeClosedRequests();
  },
  methods: {
    async viewLocation(truckRequest) {
      const truckRes = await fb.db
        .collection("trucks")
        .where("driver.uid", "==", truckRequest.scheduledDriver.uid)
        .limit(1)
        .get();
      if (truckRes.size) {
        truckRes.forEach((tr) => {
          this.currentTruck = {
            ...tr.data(),
            displayName: utils.truckName(tr.data()),
          };
        });
        this.truckLocationUrl = null;
        if (
          !this.currentTruck.lastTrack ||
          !this.currentTruck.lastTrack.address
        ) {
          this.iframe = `<div style="padding: 20px; text-align: center; color: #888;">No location data available for this truck.</div>`;
          this.dialog = true;
          return;
        }
        const {
          street,
          city,
          state,
          zip,
        } = this.currentTruck.lastTrack.address;
        this.truckLocationUrl =
          "https://www.google.com/maps/embed/v1/search?key=AIzaSyBOalWvMzUlY03jnN9AAJCOB3Z64szBalM&q=" +
          street +
          "+" +
          city +
          "," +
          state +
          "+" +
          zip;
        this.iframe = `<iframe
            v-if="currentTruck"
            width="100%"
            height="500"
            frameborder="0"
            style="border:0"
            src="${this.truckLocationUrl}"
            allowfullscreen
          >
          </iframe>`;
        //   this.truckLocationUrl =
        //     "https://www.google.com/maps/embed/v1/view?key=AIzaSyBOalWvMzUlY03jnN9AAJCOB3Z64szBalM&center=" +
        //     this.currentTruck.geometry.coordinates[1] +
        //     "," +
        //     this.currentTruck.geometry.coordinates[0] +
        //     "&zoom=15&maptype=roadmap";
      } else {
        this.currentTruck = null;
      }
      this.dialog = true;
    },
  },
};
</script>
